import i18n from '@/i18n'

export default [
  {
    path: '/baseInfo',
    meta: {
      title: i18n.t('menu.basicInfo'),
      leftMenuCode: 'User'
    },
    component: () => import('@/views/baseInfo/index.vue')
  }
]